// extracted by mini-css-extract-plugin
export default {"container":"AuthCallbackPage_container__2hxWg","card":"AuthCallbackPage_card__4hN4G","spinner":"AuthCallbackPage_spinner__FktT8","spin":"AuthCallbackPage_spin__-clpO"};